<template>
<div class="position-relative"  id="productheaderdiv">
    <div class="jumbotron-container sticky-top d-none" id="productheader" ref="productHeaderSmall">
        <div class="jumbotron jumbotron-fluid bg-primary  py-3"> <!--jumbotron-produktwelt-gradient-gray-->
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-12 col-md-6 truncated">
                            <span class="h3 font-weight-lighter text-white">{{product_data.type}}</span>
                    </div>
                    <div class="col text-md-right">
                        <span class="mb-0 mt-2 text-white">{{__('lang.short.ref_no')}} {{product_data.ref_no}} - {{product_data.version}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="jumbotron-container mb-5 bg-gradient" ref="productHeaderBig">
        <div class="jumbotron jumbotron-fluid jumbotron-fixed jumbotron-select jumbotron-overflow text-white" ref="productHeader">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-md-8">
                        <h2 class="h1 mt-5">{{product_data.type}}</h2>
                        <h1 class="h4 mb-0 font-weight-light">{{product_data.description_short}}</h1>
                    </div>
                    <!--  <div class="col-12 col-md-4" v-for="(media, mediaIndex) in product_data.product_media.filter(item => item.media_type === 'image')">
                     <b-img class="img-fluid"  :src="media_dir + media.path + '/'+ media.filename"></b-img>
                </div> -->
                    <div class="col-12 col-md-4">
                        <b-img v-show="mediaserver_url + product_data.image !='undefined' && mediaserver_url + product_data.image !=''" class="img-fluid" :src="mediaserver_url+product_data.image"></b-img>
                    </div>

                </div>
            </div>
        </div>

    </div>
</div>
</template>

<script>
    import productdataApi from './services/api/productdataAPI.js'
    export default {
         computed: {
            selectedAccessories:{
                get () {
    			    return this.$store.state.shoppingcart.selectedAccessories
    		    },
            },
            selectedFans: {
                get() {
                    return this.$store.state.shoppingcart.selectedFans
                },
            },
            product_data:{
                get () {
    			    return this.$store.state.productdata.product_data
    		    },
            },
            accessories:{
              get(){
                return this.$store.state.productdata.accessories
              },
              set(value){
                this.$store.commit('productdata/setAccessories',value);

              }
            },
           /*  media_dir : {
              get () {
                  return this.$store.state.productdata.media_dir
              },
            }, */
            session: {
              get () {
                return this.$store.state.user.session
              },
              set (value) {
                    this.$store.commit('user/updateSession', value)
                }
            },
            user: {
              get () {
                return this.$store.state.user.user
              },
              set (value) {
                    this.$store.commit('user/updateUser', value)
                }
            },
            selectedlocale: {
                get() {
                    return this.$store.state.user.selectedlocale
                },
                set(value) {
                    this.$store.commit('user/updateSelectedlocale', value)
                }
            },
        },
        data() {
			return {
                mediaserver_url: '',//'https://globalstest.heliosventilatoren.de'


    		}
		},
        methods : {
            async getProductAccessories(){
                var params={ref_no: this.product_data.ref_no,version: this.product_data.version}
                this.accessories = []
                productdataApi.getProductAccessories(params)
                .then(response => {
                    console.log('response.data.accessories')
                    console.log(response.data.productaccessories)

                    this.accessories=response.data.productaccessories
                })
                    .catch(function () {

                    console.log('getProductAccessories Error');
                });
            },
            handleScroll() {
                const productHeaderSmall = this.$refs.productHeaderSmall;
                const productHeaderBig = this.$refs.productHeaderBig;
                const offset = this.$parent.$refs.productdesc.$el.offsetTop - this.$root.$refs.proddetsticky.$el.offsetHeight   //this.$parent.$refs.productdetail.$el.offsetTop //- this.$refs.header.offsetHeight;
                const scroll = window.scrollY;

                if (scroll >= offset) {
                    productHeaderSmall.classList.remove('d-none');
                    productHeaderBig.classList.add('d-none');
                } else {
                    productHeaderSmall.classList.add('d-none');
                    productHeaderBig.classList.remove('d-none');
                }
            }

        },


        mounted() {
            /*// Init bootstrap tooltips and popovers
            this.$nextTick(() => {
                $(this.$refs.tooltipElement).tooltip();
                // If you have other elements with data-toggle="popover", initialize them here.
            });
*/
            // Change icon navigation on scroll
            if (this.$refs.productHeader) {
                this.handleScroll(); // Call the function initially to set the initial state

                window.addEventListener('scroll', this.handleScroll);
            }
        },
        destroyed() {
            // Cleanup event listener to avoid memory leaks
            window.removeEventListener('scroll', this.handleScroll);
        },



    }


</script>
<style scoped>
#productheader.sticky-top {
    //position: sticky;
    position: fixed;
    top: 0;  /*4.1875rem;*/
    z-index: 1000; /* Adjust as needed based on your layout */
    width: 100%;
}
@supports (position: sticky)
.sticky-top {
    position: fixed;
    top: 0;
    z-index: 1020;
}
#productheaderdiv.sticky-top {
    position: sticky;
    top: 4.1875rem;
    z-index: 1000; /* Adjust as needed based on your layout */
}
#productheaderdiv{
    height: 35rem;
}
@media (min-width: 576px) {
    #productheaderdiv{
        height: 35rem;
    }
}

@media (min-width: 768px) {
    #productheaderdiv{
        height: 20rem;
    }
}


@media (min-width: 992px) {
    #productheaderdiv{
        height: 20rem;
    }
}


@media (min-width: 1200px) {
    #productheaderdiv{
        height: 25rem;
    }
}

@media (min-width: 1400px) {
    #productheaderdiv{
        height: 25rem;
    }
}
/* Media query for small devices (adjust the max-width as needed)*/
@media (max-width: 767px) {

    .col-md-6.truncated span {
        /*display: none;*/
        color: #e20020 !important;
    }
}


.jumbotron {

    /*background-color: #006838 !important;*/
    background-color: #e20020 !important

}
.jumbotron-select{
    background: none !important;
    overflow: visible;

}
.pt-3, .py-3 {
    padding-top: 2rem !important;
}


</style>
